/* @flow */

import * as React from 'react';

import {FormattedTimestamp} from '../../timestamp';
import {Body} from '../../typography';

type Props = {|
    description: ?string,
    role?: ?string,
    phoneNumber: ?string,
    phoneExtension?: ?string,
    email: ?string,
    lastContactedTime?: ?string,
    connectButtonsRow?: React.Node,
|};

export function ContactCardContents(props: Props) {
    const lastContactedTimeText = props.lastContactedTime ? (
        <div className='flex'>
            Contacted&nbsp;
            <FormattedTimestamp
                datetime={Number(props.lastContactedTime)}
                format={FormattedTimestamp.formats.monthDayYear}
            />
        </div>
    ) : (
        'Never contacted'
    );

    return (
        <>
            <div className='flex flex-dir-col gap-2 word-break'>
                {props.description && (
                    <Body size='small' as='div'>
                        {props.description}
                    </Body>
                )}
                {props.role && (
                    <Body size='small' as='div'>
                        {props.role}
                    </Body>
                )}
                {props.phoneNumber && (
                    <Body size='small' as='div'>
                        {props.phoneNumber} {props.phoneExtension && `ext. ${props.phoneExtension}`}
                    </Body>
                )}
                {props.email && (
                    <Body size='small' as='div'>
                        {props.email}
                    </Body>
                )}
                {props.lastContactedTime && (
                    <Body size='small' color='placeholder'>
                        {lastContactedTimeText}
                    </Body>
                )}
            </div>
            {props.connectButtonsRow}
        </>
    );
}
